import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

export default defineComponent({
    name: 'timeout',
    mixins: [BaseComponent],
    data: function () {
        return {
            delay_expn: 0,
            //actions: [],
            //actions_compiled: false,
        }
    },
    computed: {
    },
    created() {
        this.delay_expn = utils.compileExpression(this, this.controlData.Delay);
    },
    //Mounted Replaced with preRenderComplete
    unmounted() {
        this.Stop();
    },
    methods: {
        preRenderComplete() {
            if (this.controlData.StartImmediately)
                this.Start();
            this.finishRenderHandler(this);
        },
        Start() {
            const delay = utils.evaluate(this.delay_expn, this);

            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.invokeActions();
                    this.timeout = null;
                }, delay);
            }
        },
        Stop() {
            if (this.timeout)
                clearTimeout(this.timeout);

            this.timeout = null;
        },
        async invokeActions() {
            utils.executeAndCompileAllActions(this.controlData.Actions, null, this);
        }
    },
    props: {
    },
    render() {
        return null;
    }
});